export default __webpack_public_path__ + "static/media/cnc.8e0a24d8.webp";